<template>
    <div class="articles-list container text-white">
        <list-post-item
            v-for="(post, index) in blogPosts"
            :key="index"
            :blog-post="post"
            :even-list-item="(index+1)%2 === 0"
            :labels="labels"
            class="mb-20" />
    </div>
</template>

<script>
import ListPostItem from '@web/components/Blog/ListPostItem';

export default {
  name: 'ListPosts',
  components: { ListPostItem },
  props: {
    blogPosts: {
      type: Array,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },
};
</script>
